import { IGraphqlMapper } from './I-graphql-mapper';

export abstract class IGraphqlPagedMapper implements IGraphqlMapper {
  abstract items: any[];
  abstract total: number;
  abstract returnFromJson(json: any): { items: any[]; total: number };
}
